// L'ARRÊT SUR IMAGE (26/07, chantier « plus ludique et jouissif » choisi par Claude-Alain).
//
// Ce qui manquait au jeu : rien ne PÈSE. Un moine tombe dans le trou qu'on vient de creuser, le
// meilleur moment de la partie, et il ne se passe rien de plus qu'un blip. Dans un jeu d'action,
// ce poids se fabrique en FIGEANT tout pendant un dixième de seconde : le cerveau lit l'arrêt comme
// un impact, et le mouvement qui reprend juste après paraît plus vif qu'avant.
//
// ⚠️ POURQUOI C'EST SANS DANGER ICI. La boucle (client/loop.ts) a déjà un gel : `running` renvoie
// faux, la simulation n'avance pas ET le temps écoulé pendant le gel est JETÉ. Donc :
//   · le chrono ne bouge pas (il se déduit du nombre de ticks, pas de l'horloge) ;
//   · le fantôme reste synchrone (lui aussi avance d'un tick pour un tick) ;
//   · le hash d'état n'est pas touché — rien ici n'entre dans la simulation.
// Et comme seul le solo passe un `running` à la boucle, l'arrêt sur image ne peut pas désynchroniser
// une partie en ligne : le serveur y tient la cadence, personne ne la fige de son côté.

/** Durées, en millisecondes. Assez longues pour se sentir, assez courtes pour ne jamais gêner. */
export const HITSTOP_MS = {
  /** Un moine tombe dans ton trou : le sommet du jeu, il mérite le plus long. */
  moinePiege: 120,
  /** La dernière pièce du niveau : l'instant où la sortie s'ouvre. */
  dernierePiece: 90,
  /** Un coup de maillet ENCAISSÉ (05/08) : bref, mais le coup doit peser. */
  malletHit: 70,
} as const

/**
 * Le gel est actif tant que `maintenant` n'a pas dépassé `jusqua`. Fonction PURE : l'horloge est
 * passée en argument pour que la règle soit vérifiable sans navigateur.
 *
 * `jusqua = 0` (jamais déclenché) ne gèle rien, y compris à l'instant 0.
 */
export function figeA(jusqua: number, maintenant: number): boolean {
  return jusqua > 0 && maintenant < jusqua
}

/**
 * Nouvelle échéance de gel : on ne RACCOURCIT jamais un arrêt en cours (deux moines piégés coup sur
 * coup ne doivent pas produire un gel plus court que le premier), et on ne cumule pas non plus —
 * sinon une cascade figerait le jeu une seconde entière.
 */
export function prolonge(jusqua: number, maintenant: number, dureeMs: number): number {
  return Math.max(jusqua, maintenant + dureeMs)
}

// --- l'état vivant (module) : le contrôleur solo déclenche, la boucle interroge ---------------------
let jusqua = 0

export function declencheHitstop(dureeMs: number, maintenant: number): void {
  jusqua = prolonge(jusqua, maintenant, dureeMs)
}

export function hitstopActif(maintenant: number): boolean {
  return figeA(jusqua, maintenant)
}

/** À appeler au changement de niveau / de partie : une échéance qui traîne gèlerait le début. */
export function resetHitstop(): void {
  jusqua = 0
}
